{
  "title": "Transparency",
  "lead": "Budgets, reports, bids and awards, ordinances and the people in charge — published by the LGU.",
  "tab_documents": "Documents",
  "tab_bids": "Bids & awards",
  "tab_ordinances": "Ordinances",
  "tab_officials": "Officials",
  "fdpLead": "Under the Full Disclosure Policy, LGUs post their budgets, financial reports, procurement plans and other key documents for everyone to see.",
  "noDocuments": "No documents published yet",
  "noDocumentsBody": "Documents appear here when the LGU publishes them.",
  "noDocumentsMatch": "No documents match these filters",
  "moreInCategory": "{count} more in the document library",
  "openLibrary": "Open the document library",
  "libraryTitle": "Documents",
  "libraryLead": "Every document the LGU has published. Filter by type, year or office.",
  "searchDocuments": "Search documents",
  "category": "Type of document",
  "allCategories": "All types",
  "year": "Year",
  "allYears": "All years",
  "office": "Office",
  "allOffices": "All offices",
  "clearFilters": "Clear filters",
  "results": "Documents found",
  "backToTransparency": "Back to Transparency",
  "yearLabel": "Year {year}",
  "postedOn": "Posted {date}",
  "download": "Open",
  "downloadSize": "Open ({size})",
  "downloadNamed": "Open {title}",
  "cat_budget": "Budget",
  "cat_financial_reports": "Financial reports",
  "cat_procurement_plan": "Annual procurement plan",
  "cat_plans_programs": "Plans & programs",
  "cat_executive_orders": "Executive orders",
  "cat_ordinances_resolutions": "Ordinances & resolutions",
  "cat_forms": "Forms",
  "cat_reports": "Reports",
  "cat_other": "Other",
  "bidsLead": "Projects and purchases open for bidding, and who won the contracts.",
  "filterStatus": "Filter by status",
  "all": "All",
  "bid_open": "Open for bidding",
  "bid_under_evaluation": "Under evaluation",
  "bid_awarded": "Awarded",
  "bid_failed": "Failed bidding",
  "bid_cancelled": "Cancelled",
  "noBids": "No bids posted yet",
  "noBidsStatus": "None with this status",
  "abc": "Approved budget",
  "mode": "Procurement mode",
  "posted": "Posted",
  "deadline": "Bid submission deadline",
  "deadlineOn": "Deadline {date}",
  "opening": "Bid opening",
  "awardedTo": "Awarded to",
  "philgeps": "PhilGEPS reference",
  "bidDetails": "Details and documents",
  "byOffice": "Posted by {office}",
  "ordinancesLead": "Ordinances and resolutions of the Sangguniang Bayan, from filing to approval.",
  "searchOrdinances": "Search by title, number or author",
  "filterStage": "Filter by stage",
  "state_pending": "In progress",
  "state_final": "Done",
  "noOrdinances": "No measures in the tracker yet",
  "noOrdinancesMatch": "No measures match",
  "kind_ordinance": "Ordinance",
  "kind_resolution": "Resolution",
  "stage_filed": "Filed",
  "stage_first_reading": "First reading",
  "stage_committee": "In committee",
  "stage_public_hearing": "Public hearing",
  "stage_second_reading": "Second reading",
  "stage_third_reading": "Third reading",
  "stage_approved": "Approved",
  "stage_adopted": "Adopted",
  "stage_enacted": "Signed into law",
  "stage_lapsed": "Lapsed into law",
  "stage_vetoed": "Vetoed",
  "authors": "Authors: {names}",
  "progress": "Progress",
  "done": "done",
  "notYet": "not yet",
  "history": "Summary and history",
  "readText": "Read the full text",
  "noOfficials": "The officials directory hasn't been published yet",
  "group_elected": "Elected officials",
  "group_department_head": "Department heads",
  "group_barangay": "Barangay officials",
  "term": "Term: {from} to {to}",
  "callNamed": "Call {name}",
  "emailNamed": "Email {name}",
  "staffLead": "Publish your office's documents, bids and awards, and its entries in the officials directory. Residents see them under Transparency.",
  "noCapability": "Your office doesn't publish here. Ask the LGU administrator if it should.",
  "saved": "Saved.",
  "hidden": "Hidden",
  "hide": "Hide",
  "show": "Show",
  "open": "Open",
  "visible": "Show to the public",
  "currentFile": "Current file",
  "file": "File",
  "fileHint": "PDF or a clear scan, up to 2 MB after upload.",
  "fileTooBig": "That file is too big. Use a PDF under 12 MB.",
  "chooseFile": "Choose a file",
  "replaceFile": "Replace file",
  "uploading": "Uploading…",
  "staffDocsLead": "Budgets, reports, plans and other documents your office posts for the public.",
  "staffNoDocs": "Your office hasn't published documents yet",
  "newDocument": "New document",
  "editDocument": "Edit document",
  "docTitle": "Title",
  "postedDate": "Date posted",
  "description": "Description",
  "staffBidsLead": "Invitations to bid, their status and awards.",
  "staffNoBids": "Your office hasn't posted bids yet",
  "newBid": "New bid",
  "editBid": "Edit bid",
  "refNo": "Reference number",
  "status": "Status",
  "bidTitle": "Project or purchase",
  "abcPeso": "Approved budget (₱)",
  "modePlaceholder": "e.g. Public bidding",
  "awardPeso": "Contract amount (₱)",
  "awardedOn": "Date awarded",
  "bidDocuments": "Documents",
  "docLabel": "Document {n} name",
  "removeDoc": "Remove {label}",
  "addBidDocument": "Add a document",
  "staffOfficialsLead": "Officials your office lists in the public directory. Use the arrows to set their order.",
  "staffNoOfficials": "Your office hasn't listed any officials yet",
  "newOfficial": "New official",
  "editOfficial": "Edit official",
  "personName": "Name",
  "position": "Position",
  "positionPlaceholder": "e.g. Municipal Treasurer",
  "groupField": "Group",
  "linkedOffice": "Office they lead or belong to",
  "noOffice": "None",
  "termStart": "Term starts",
  "termEnd": "Term ends",
  "publicEmail": "Public email",
  "publicPhone": "Public phone",
  "photo": "Photo",
  "photoHint": "Optional. An official photo; skipped in low-data mode.",
  "photoAlt": "Photo of {name}",
  "addPhoto": "Add a photo",
  "replacePhoto": "Replace photo",
  "removePhoto": "Remove photo",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "staffOrdinancesLead": "Track each ordinance and resolution from filing to approval. Residents follow the stages on the Transparency page.",
  "staffNoOrdinances": "No measures in the tracker yet",
  "newOrdinance": "New measure",
  "editOrdinance": "Edit measure",
  "kind": "Kind",
  "number": "Number",
  "numberHint": "Once it has one, e.g. Ordinance No. 12, s. 2026.",
  "ordTitle": "Title",
  "authorsField": "Authors or sponsors",
  "summary": "Summary",
  "ordFile": "Full text",
  "ordFileHint": "Optional. PDF of the measure as filed or approved.",
  "stagesTitle": "Stages",
  "stagesHint": "Start with the filing date. Add each step as it happens; they are sorted by date.",
  "stageN": "Stage {n}",
  "stage": "Stage",
  "stageDate": "Date",
  "committee": "Committee",
  "hearingTime": "Time",
  "venue": "Venue",
  "stageNote": "Note",
  "removeStage": "Remove this stage",
  "addStage": "Add the next stage",
  "lastAction": "Last action {date}",
  "showingFor": "Showing results for “{q}”.",
  "showAll": "Show all"
}
